// eslint-disable-next-line
import Shp from './workers/shpfile.worker';
import Text from  './workers/text.worker';
const toGeoJSON = {
  fromText: function (file, cb) {
    const text = new Text();
    text.postMessage(file);
    text.onmessage = function (event) {
      cb(event);
    };
  },

  fromShp: function (file, cb) {
    const shp = new Shp();
    shp.postMessage(file);
    shp.onmessage = function (event) {
      cb(event);
    };
  },

};

export default toGeoJSON;